import { render } from "./SlaughterSheetPrint.vue?vue&type=template&id=a8ff2ba2"
import script from "./SlaughterSheetPrint.vue?vue&type=script&lang=js"
export * from "./SlaughterSheetPrint.vue?vue&type=script&lang=js"

import "./SlaughterSheetPrint.vue?vue&type=style&index=0&id=a8ff2ba2&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__